import type { ApiDocument } from '../../api/types';

import { SVG_EXTENSIONS } from '../../config';

const SVG_MIME_TYPE = 'image/svg+xml';
const UNSAFE_MIME_TYPES = new Set(['text/html', SVG_MIME_TYPE]);
const UNSAFE_EXTENSIONS = new Set([
  ...SVG_EXTENSIONS,
  'htm', 'html', 'svg', 'm4v', 'm3u', 'm3u8', 'xhtml', 'xml',
]);

function getMimeBase(mimeType?: string) {
  return mimeType?.split(';', 1)[0]?.trim().toLowerCase();
}

function isSvgMedia({ mimeType, extension }: { mimeType?: string; extension?: string }) {
  return getMimeBase(mimeType) === SVG_MIME_TYPE || Boolean(extension && SVG_EXTENSIONS.has(extension));
}

export function isTrustedGeneratedInlineSvg(
  document: ApiDocument,
  extension?: string,
) {
  const { trustedInlinePreview } = document;

  return isSvgMedia({ mimeType: document.mimeType, extension })
    && trustedInlinePreview?.type === 'generatedSvg'
    && trustedInlinePreview.source === 'agent'
    && trustedInlinePreview.sanitized === true;
}

export function isIpRevealingMedia({ mimeType, extension }: { mimeType?: string; extension: string }) {
  if (mimeType && UNSAFE_MIME_TYPES.has(getMimeBase(mimeType) ?? mimeType)) {
    return true;
  }

  if (UNSAFE_EXTENSIONS.has(extension)) {
    return true;
  }

  return false;
}

export function isDocumentIpRevealingMedia(document: ApiDocument, extension: string) {
  if (isTrustedGeneratedInlineSvg(document, extension)) {
    return false;
  }

  return isIpRevealingMedia({ mimeType: document.mimeType, extension });
}
